$('.blog-posts').slick({
    centerMode: false,
    centerPadding: '00px',
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: false,
    dots: false,
    autoplay: true,
    autoplaySpeed: 2500,
    responsive: [
        {
            breakpoint: 1300,
            settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '0px',
                slidesToScroll: 1,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '0px',
                slidesToScroll: 1,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 750,
            settings: {
                arrows: false,
                dots: false,
                centerMode: false,
                centerPadding: '0px',
                slidesToScroll: 1,
                slidesToShow: 1
            }
        }
    ]
});

document.querySelectorAll('.blog-posts-article').forEach(function (item) {
  item.removeAttribute('aria-describedby');
});
